import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CapacitorShareTarget } from '@capgo/capacitor-share-target';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import './utils/logger'; // Initialize console interceptor

if (typeof window !== 'undefined') {
    window.addEventListener('error', (event) => {
        if (event.message === 'Script error.' || !event.filename) {
            event.stopImmediatePropagation();
            event.preventDefault();
        }
    }, true);
}

if (typeof window !== 'undefined' && (window as any).Capacitor) {
    CapacitorShareTarget.addListener('shareReceived', (event: any) => {
        (window as any).cachedShareIntent = event;
        try {
            localStorage.setItem('pending_share_intent', JSON.stringify(event));
        } catch (e) {
            console.error('Failed to store pending_share_intent', e);
        }
        window.dispatchEvent(new CustomEvent('shareIntentReceived', { detail: event }));
    }).catch(console.error);
    
    CapacitorUpdater.notifyAppReady().catch(console.error);
}

(window as any).logToNative?.('Index.tsx entry point reached');

if (typeof window !== 'undefined' && window.self !== window.top) {
    (window as any).logToNative?.('App is running inside an iframe, blocking render to prevent clickjacking/looping');
    const rootEl = document.getElementById('root');
    if (rootEl) {
        rootEl.innerHTML = '<div style="padding: 20px; text-align: center; color: #666; font-family: sans-serif;">Framing GoodLyfe is not allowed.</div>';
    }
} else {
    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
